<template>
    <div class="zoom-container" @mousemove="handleMouseMove" @mouseleave="handleMouseLeave">
        <img :src="src" ref="image" :style="imageStyle" />
    </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
    src: {
        type: String,
        required: true,
    },
    zoomScale: {
        type: Number,
        default: 2,
    },
});

const image = ref(null);
const imageStyle = ref({
    transform: 'scale(1)',
    transformOrigin: 'center center',
    transition: 'transform 0.3s ease',
});

const handleMouseMove = (e) => {
    const rect = image.value.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;

    imageStyle.value = {
        transformOrigin: `${x}% ${y}%`,
        transform: `scale(${props.zoomScale})`,
        transition: 'transform 0.1s ease',
    };
};

const handleMouseLeave = () => {
    imageStyle.value = {
        transformOrigin: 'center center',
        transform: 'scale(1)',
        transition: 'transform 0.3s ease',
    };
};
</script>

<style scoped>
.zoom-container {
    overflow: hidden;
    display: inline-block;
    position: relative;
    cursor: zoom-in;
    /* max-height: 150px; */
}

.zoom-container img {
    display: block;
    max-width: 100%;
    height: auto;
    will-change: transform;
}
</style>